import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import NoteMdEditor from "@/views/md-editor/NoteMdEditor.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'noteDraftManager',
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(NoteMdEditor));
        };
    }
});
